import React from 'react';
import { Package, ShoppingCart, CheckCircle, Clock } from 'lucide-react';
import './styles/FeaturesCart.css';

const features = [
  { icon: Package, text: 'Low Prices', color: '#FF9800' },
  { icon: ShoppingCart, text: 'No Minimum Order', color: '#4CAF50' },
  { icon: CheckCircle, text: '100% Original', color: '#FF9800' },
  { icon: Clock, text: 'Delivery on Time', color: '#2196F3' }
];

const FeaturesCart: React.FC = () => {
  return (
    <div className="features-cart-wrapper">
      <div className="features-cart-card">
        {features.map((feature, index) => (
          <div key={index} className="features-cart-item">
            <div className="features-cart-icon-circle" style={{ backgroundColor: `${feature.color}15` }}>
              <feature.icon size={22} strokeWidth={2.2} className="features-cart-icon" style={{ color: feature.color }} />
            </div>
            <span className="features-cart-label">{feature.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesCart;